export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-interface-e2c21faaed855884c8184c1a688ed499.png";